import { action } from 'typesafe-actions';

import { City } from 'models/city';

export const CITIES_REQUEST = 'CITIES_REQUEST';
export const CITIES_SUCCESSFUL = 'CITIES_SUCCESSFUL';
export const CITIES_FAILURE = 'CITIES_FAILURE';

export const citiesRequest = () => action(CITIES_REQUEST);

export const citiesSuccessful = (cities: City[]) => action(CITIES_SUCCESSFUL, cities);

export const citiesError = (error: string) => action(CITIES_FAILURE, error);
